import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498",
  fill: "#fff"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "Group_4237",
  "data-name": "Group 4237",
  transform: "rotate(-90 23.795 26.795)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_8039",
    "data-name": "Path 8039",
    class: "cls-1",
    d: "M24.262 3 12 15.262l2.4 2.4 8.128-8.128v35.578h3.509V9.576l8.087 8.085 2.4-2.4Z",
    transform: "translate(14.065)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_8040",
    "data-name": "Path 8040",
    class: "cls-1",
    d: "M15.5 38.577V3h-3.512v35.535L3.9 30.45l-2.4 2.4 12.263 12.262L26.025 32.85l-2.4-2.4Z"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };